import Styled from "./custom-styled-icon";
import { createSvgIcon } from '@mui/material';

export const LowestMinQty = Styled(createSvgIcon(
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="18" height="18" rx="9" fill="#E4C2D6" />
        <path
            strokeWidth="1.2"
            fillRule="evenodd" clipRule="evenodd"
            d="M14.625 10.1842V13.1447L12.0194 14.625V11.6645L14.625 10.1842ZM9.013 13.1447L11.6186 14.625V11.6645L9.013 10.1842V13.1447ZM3 13.1447L5.60571 14.625V11.6645L3 10.1842V13.1447ZM8.8125 3.375L6.267 4.8211L8.8125 6.2672L11.358 4.82124L8.8125 3.375ZM6.00657 14.625L8.61214 13.1447V10.1842L6.00657 11.6645V14.625ZM5.80607 8.36223L3.20036 9.8425L5.80607 11.3228L8.41163 9.8425L5.80607 8.36223ZM9.013 9.50096L11.5585 8.05485V5.16265L9.013 6.60875V9.50096ZM8.61214 6.60875L6.06678 5.16265V8.05485L8.61228 9.50109L8.61214 6.60875ZM11.8191 8.36237L9.21351 9.84264L11.8191 11.3229L14.4246 9.84264L11.8191 8.36237Z"
            fill="#934082"
        />
    </svg>,
    "LowestMinQty"
))

export default LowestMinQty;
